import { render } from "./WithdrawConfirmationPage.vue?vue&type=template&id=584839da&scoped=true"
import script from "./WithdrawConfirmationPage.vue?vue&type=script&lang=js"
export * from "./WithdrawConfirmationPage.vue?vue&type=script&lang=js"

import "./WithdrawConfirmationPage.vue?vue&type=style&index=0&id=584839da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584839da"]])

export default __exports__